import { CarsState } from "../../types";

export const resetEBoxDashboardData = (state: CarsState) => {
  state.eBoxDashboardData = {};
};
